"use client";

import Image from "next/image";
import Link from "next/link";
import { useTranslations } from 'next-intl';
import { montserratExtraBold, montserratMedium } from "@/app/fonts";
import StickyNav from "@/app/components/sticky-nav";
import SiteFooter from "@/app/components/site-footer";

export default function DownloadPage() {
  const t = useTranslations('download');
  return (
    <div className="relative min-h-screen overflow-hidden bg-[color:var(--background)] text-[color:var(--text-primary)]">
      <StickyNav />
      <main className="relative z-10 flex flex-col min-h-screen">
        {/* Main Download Section */}
        <section className="relative z-10 flex flex-col items-center justify-center min-h-screen px-6 py-24 sm:px-12">
          <div className="flex flex-col items-center gap-12 max-w-4xl">
            {/* Title */}
            <h1 className={`${montserratExtraBold.className} text-[3rem] md:text-[4rem] text-center text-white`}>
              {t('title')}
            </h1>

            {/* Download Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full max-w-2xl">
              {/* iOS & iPadOS Card */}
              <Link
                href="https://testflight.apple.com/join/2QfGUnXz"
                className="min-h-[246px] group relative flex flex-col items-center justify-center gap-6 p-8 border border-white/20 rounded-3xl bg-[color:var(--card-surface)] hover:border-white/40 transition-all duration-300 hover:shadow-[0_8px_30px_rgba(11,113,255,0.2)]"
              >
                <div className="relative">
                  {/* Phone Icon with Apple Logo */}
                  <div className="relative w-32 h-32 flex items-center justify-center">
                    <Image
                      src="/assets/ios-download.svg"
                      alt={t('iosAlt')}
                      width={208}
                      height={208}
                      className="absolute top-0 right-0 scale-100 group-hover:scale-0 transition-transform duration-300 origin-center"
                    />
                    <Image
                      //src="/assets/qr-code-temp.svg"
                      src="/assets/ios-download.svg"
                      alt={t('qrCodeAlt')}
                      width={208}
                      height={208}
                      className="absolute top-0 right-0 scale-0 group-hover:scale-100 transition-transform duration-300 origin-center"
                    />
                  </div>
                </div>
                <span className={`${montserratMedium.className} text-lg text-white block group-hover:hidden uppercase tracking-wide whitespace-pre-line text-center`}>
                  {t('iosIpad')}
                </span>
                <span className={`${montserratMedium.className} text-sm text-[var(--main-color)] hidden group-hover:block tracking-wide`}>
                  {t('scanToDownload')}
                </span>
              </Link>

              {/* Android Card */}
              <Link
                href="/download/android/xox_v1.0.1-2.apk"
                className="min-h-[246px] group relative flex flex-col items-center justify-center gap-6 p-8 border border-white/20 rounded-3xl bg-[color:var(--card-surface)] hover:border-white/40 transition-all duration-300 hover:shadow-[0_8px_30px_rgba(11,113,255,0.2)]"
              >
                <div className="relative">
                  {/* Phone Icon with Android Logo */}
                  <div className="relative w-32 h-32 flex items-center justify-center">
                    <Image
                      src="/assets/android-download.svg"
                      alt={t('androidAlt')}
                      width={208}
                      height={208}
                      className="absolute top-0 right-0 scale-100 group-hover:scale-0 transition-transform duration-300 origin-center"
                    />
                    <Image
                      src="/assets/qr-code-android.svg"
                      alt={t('qrCodeAlt')}
                      width={208}
                      height={208}
                      className="absolute top-0 right-0 scale-0 group-hover:scale-100 transition-transform duration-300 origin-center"
                    />
                  </div>
                </div>
                <span className={`${montserratMedium.className} text-lg text-white block group-hover:hidden uppercase tracking-wide`}>
                  {t('android')}
                </span>
                <span className={`${montserratMedium.className} text-sm text-[var(--main-color)] hidden group-hover:block tracking-wide`}>
                  {t('scanToDownload')}
                </span>
              </Link>
            </div>
          </div>
        </section>

        <SiteFooter />
      </main>
    </div>
  );
}
